module.exports = __webpack_public_path__ + "img/icon_more.677b9de7.png";